<template>
    <div>
        <div class="signup-header row border-bottom-light row justify-content-sm-center">
            <div class="col-sm-6">
                <h5 class="color-1">Your business</h5>
                <h2>Can you tell me a little bit about your business?</h2>
            </div>
        </div>

        <div class="row justify-content-sm-center">
            <div class="col-lg-6 col-md-8 col-sm-12">
                <form class="shaded" @submit.stop.prevent="processFormFinish" novalidate>
                    <avatar-uploader placeholder="agent" :loadThisImage="accountSetup.imageLogoBase64" @uploadComplete="addUploadedAvatar"></avatar-uploader>

                    <div class="form-group mb-2">
                        <label class="full">
                            Company name<span class="brand ml-1">*</span>
                            <input v-model="form.companyName" type="text" placeholder="Company name">
                        </label>

                        <div v-if="$v.form.companyName.$invalid" class="error">
                            <span v-if="!$v.form.companyName.required">Company name is required.</span>
                            <span v-if="!$v.form.companyName.minLength">Your company name must have at least 4 characters.</span>
                        </div>
                    </div>

                    <div v-if="getChannelSalesList" class="form-group mb-2">
                        <label class="full">Business Type<span class="brand ml-1">*</span></label>

                        <vSelect
                            label="description"
                            :value="selectedSalesChannel"
                            :options="getChannelSalesList"
                            placeholder="Pick a sales channel ..."
                            @input="updateSalesChannel">
                        </vSelect>

                        <div v-if="$v.form.salesChannel.$invalid" class="error">
                            <span v-if="!$v.form.salesChannel.required">Business type is required.</span>
                        </div>
                    </div>

                    <div class="form-group mb-2">
                        <label class="full">
                            Website
                            <input v-model="form.website" type="text" placeholder="www.website.com">
                        </label>

                        <div v-if="$v.form.website.$invalid" class="error">
                            <span v-if="!$v.form.website.isWebsiteValid">Must be a valid website.</span>
                        </div>
                    </div>

                    <div class="row mt-5 mb-1">
                        <div class="col-md-6">
                            <router-link :to="{ name: 'auth.signup.agent' }">
                                <input type="button" class="btn tertiary widest full" value="Back">
                            </router-link>
                        </div>

                        <div class="col-md-6 text-center">
                            <button type="submit" class="btn blue widest full" value="Submit" :disabled="$v.$invalid || submittingRegistration">
                                <loader v-if="submittingRegistration"></loader>
                                <span v-else>Submit</span>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import { required, minLength } from 'vuelidate/lib/validators'
import { mapActions, mapGetters } from 'vuex'

import loader from '@/tools/loaders/loader1'
import AvatarUploader from '../../common/AvatarUploader'
import extendedVSelect from '@/extends/vue-select'

export default {
    data() {
        return {
            step: 2,
            form: {
                companyName:'',
                salesChannel: null,
                website:''
            },
            selectedSize: null,
            submittingRegistration: false,
            selectedSalesChannel: null,
        }
    },
    validations: {
        form: {
            companyName: {
                required,
                minLength: minLength(4)
            },
            salesChannel: {
                required
            },
            website: {
                isWebsiteValid(val) {
                    return !val || this.validWebsite(val);
                }
            },
        }
    },
    created() {
        // Redirect if we landed here without having passed through the needed steps
        if (this.accountSetup.type !== 'agent') {
            this.resetAccountSetup('agent');
            this.$router.push({ name: 'auth.signup' });
        } else {
            this.form = this.accountSetup;
            this.$set(this.form, 'salesChannel', null);
            this.eventHub.$emit('sidebar', 'create');
            this.eventHub.$emit('topLink', 'login');
        }

        // Set harcoded data
        this.$set(this.form, 'size', 10);
        this.$set(this.form, 'country', 176);
    },
    computed: {
        ...mapGetters([
            'accountSetup',
            'getChannelSalesList'
        ]),
    },
    methods: {
        ...mapActions([
            'resetAccountSetup',
            'updateAccountSetup',
            'register'
        ]),
        validWebsite(value) {
            if (!value) return false;

            return /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/\S*)?$/.test(value);
        },
        processFormFinish() {
            if (!this.submittingRegistration) {
                // Update account setup data
                this.updateAccountSetup(this.form);

                // Create an agent account via API
                this.submittingRegistration = true;

                this.register(this.parseQueryString(this.accountSetup)).then(response => {
                    this.submittingRegistration = false;
                    
                    // Reset the setup object
                    this.resetAccountSetup('agent');
                })

            } else {
                this.$toasted.info('Already submitting your registration, please wait');
            }
        },
        addUploadedAvatar(avatar) {
            this.form.imageLogoBase64 = avatar;
        },
        updateSalesChannel(e) {
            this.selectedSalesChannel = e;
            this.form.salesChannel = e.id || null;
        }
    },
    components: {
        vSelect: extendedVSelect,
        AvatarUploader,
        loader
    }
}
</script>

<style lang="scss" scoped>
    .form-group {
        min-height: 4.75rem;
    }
</style>



// WEBPACK FOOTER //
// Step2.vue?d8a86ab2